import { ChangeEvent } from 'react';
import { FormControl, MenuItem, Select } from '@material-ui/core';
import { cleanHtmlValue } from '@utils';

export const SelectComponent = (props) => {
  const { schema, handleChange, value, isMultiple, index, testId = 'select' } = props;
  const { properties, options } = schema;
  return (
    <FormControl {...properties}>
      <Select
        data-testid={testId}
        style={isMultiple ? properties : schema.style}
        value={value}
        onChange={(
          event: ChangeEvent<{
            name: string;
            value: string;
          }>
        ) => {
          return isMultiple
            ? handleChange(event, index, schema.key, false)
            : handleChange(cleanHtmlValue(event.target.value));
        }}
      >
        {options.map(({ value, label }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
